import {get} from 'api/http'


export function fetch() {
    return get('/settings/servers')
}